// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Preloader Styles */
.preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  background: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  opacity: 1;
  transform: translateY(0) scale(1);
  transition: opacity 0.6s ease, transform 0.6s cubic-bezier(0.2, 0.8, 0.2, 1), visibility 0.6s ease;
  visibility: visible;
  margin: 0;
  padding: 0;
}



.preloader-content {
  text-align: center;
  color: var(--color-neutral, #FFFEF7);
  max-width: 500px;
  width: 90%;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.preloader-logo {
  margin-bottom: 3rem;
  animation: preloader-logo-pulse 2s ease-in-out infinite;
}

@keyframes preloader-logo-pulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.8;
    transform: scale(1.02);
  }
}

.preloader-logo-text {
  font-size: 3.5rem;
  font-weight: 700;
  letter-spacing: 0.3em;
  color: var(--color-neutral, #FFFEF7);
  margin-bottom: 0.5rem;
}

.preloader-tagline {
  font-size: 1rem;
  font-weight: 300;
  letter-spacing: 0.2em;
  color: rgba(255, 254, 247, 0.85);
  text-transform: uppercase;
}

.preloader-bar-container {
  margin-top: 2rem;
}

.preloader-bar {
  width: 100%;
  height: 4px;
  background: rgba(255, 254, 247, 0.08);
  border-radius: 2px;
  overflow: hidden;
  position: relative;
  margin-bottom: 1rem;
}

.preloader-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #111 0%, #fff 50%, #111 100%);
  border-radius: 2px;
  transition: width 0.3s ease;
  animation: preloader-bar-shimmer 2s ease-in-out infinite;
  box-shadow: 0 0 15px rgba(255, 255, 255, 0.4);
}

@keyframes preloader-bar-shimmer {
  0% {
    background-position: 200% center;
  }
  100% {
    background-position: -200% center;
  }
}

.preloader-percentage {
  font-size: 0.875rem;
  font-weight: 600;
  color: rgba(255, 254, 247, 0.95);
  letter-spacing: 0.05em;
  text-align: center;
}

.preloader-loading-text {
  margin-top: 2rem;
  font-size: 0.875rem;
  font-weight: 400;
  color: rgba(255, 254, 247, 0.85);
  letter-spacing: 0.1em;
  text-transform: uppercase;
  animation: preloader-text-fade 1.5s ease-in-out infinite;
}

@keyframes preloader-text-fade {
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .preloader-logo-text {
    font-size: 2.5rem;
    letter-spacing: 0.2em;
  }

  .preloader-tagline {
    font-size: 0.875rem;
  }

  .preloader-bar {
    height: 3px;
  }
}

@media (max-width: 480px) {
  .preloader-logo-text {
    font-size: 2rem;
  }

  .preloader-tagline {
    font-size: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/preloader.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,iCAAiC;EACjC,kGAAkG;EAClG,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;;;AAIA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gEAAgE;EAChE,kBAAkB;EAClB,2BAA2B;EAC3B,wDAAwD;EACxD,6CAA6C;AAC/C;;AAEA;EACE;IACE,gCAAgC;EAClC;EACA;IACE,iCAAiC;EACnC;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gCAAgC;EAChC,qBAAqB;EACrB,yBAAyB;EACzB,wDAAwD;AAC1D;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* Preloader Styles */\n.preloader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100vw;\n  height: 100vh;\n  background: #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  opacity: 1;\n  transform: translateY(0) scale(1);\n  transition: opacity 0.6s ease, transform 0.6s cubic-bezier(0.2, 0.8, 0.2, 1), visibility 0.6s ease;\n  visibility: visible;\n  margin: 0;\n  padding: 0;\n}\n\n\n\n.preloader-content {\n  text-align: center;\n  color: var(--color-neutral, #FFFEF7);\n  max-width: 500px;\n  width: 90%;\n  padding: 2rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n.preloader-logo {\n  margin-bottom: 3rem;\n  animation: preloader-logo-pulse 2s ease-in-out infinite;\n}\n\n@keyframes preloader-logo-pulse {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.8;\n    transform: scale(1.02);\n  }\n}\n\n.preloader-logo-text {\n  font-size: 3.5rem;\n  font-weight: 700;\n  letter-spacing: 0.3em;\n  color: var(--color-neutral, #FFFEF7);\n  margin-bottom: 0.5rem;\n}\n\n.preloader-tagline {\n  font-size: 1rem;\n  font-weight: 300;\n  letter-spacing: 0.2em;\n  color: rgba(255, 254, 247, 0.85);\n  text-transform: uppercase;\n}\n\n.preloader-bar-container {\n  margin-top: 2rem;\n}\n\n.preloader-bar {\n  width: 100%;\n  height: 4px;\n  background: rgba(255, 254, 247, 0.08);\n  border-radius: 2px;\n  overflow: hidden;\n  position: relative;\n  margin-bottom: 1rem;\n}\n\n.preloader-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, #111 0%, #fff 50%, #111 100%);\n  border-radius: 2px;\n  transition: width 0.3s ease;\n  animation: preloader-bar-shimmer 2s ease-in-out infinite;\n  box-shadow: 0 0 15px rgba(255, 255, 255, 0.4);\n}\n\n@keyframes preloader-bar-shimmer {\n  0% {\n    background-position: 200% center;\n  }\n  100% {\n    background-position: -200% center;\n  }\n}\n\n.preloader-percentage {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: rgba(255, 254, 247, 0.95);\n  letter-spacing: 0.05em;\n  text-align: center;\n}\n\n.preloader-loading-text {\n  margin-top: 2rem;\n  font-size: 0.875rem;\n  font-weight: 400;\n  color: rgba(255, 254, 247, 0.85);\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  animation: preloader-text-fade 1.5s ease-in-out infinite;\n}\n\n@keyframes preloader-text-fade {\n  0%, 100% {\n    opacity: 0.5;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n/* Mobile Responsive */\n@media (max-width: 768px) {\n  .preloader-logo-text {\n    font-size: 2.5rem;\n    letter-spacing: 0.2em;\n  }\n\n  .preloader-tagline {\n    font-size: 0.875rem;\n  }\n\n  .preloader-bar {\n    height: 3px;\n  }\n}\n\n@media (max-width: 480px) {\n  .preloader-logo-text {\n    font-size: 2rem;\n  }\n\n  .preloader-tagline {\n    font-size: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
